import Vue from 'vue'
import Router from 'vue-router'


const routes = []
Vue.use(Router)

/**
 * REGISTER ROUTES HERE !
 */
import routesGlobal from '@/routes/routesGlobal'
routes.push(...routesGlobal)

import routesSections from '@/routes/routesSections'
routes.push(...routesSections)


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})
